import React from 'react';
import { Loader } from 'rsuite';
import './WeatherSensors.scss';
import { WeatherSensorsProps } from '../../../models/DevicePanel.model';

const WeatherSensors = ({ meteoData, weatherData, loading }: WeatherSensorsProps) => {
  const source = meteoData?.values ? meteoData.values : weatherData || null;
  const hasWeatherData =
    !!source && (source.temperature != null || source.pressure != null || source.humidity != null);

  const getValueColor = (value: string | number) => {
    return value && value !== 0 && value !== '0' ? 'blue-value' : 'grey-value';
  };

  const temperature = source?.temperature ?? 0;
  const pressure = source?.pressure ?? 0;
  const humidity = source?.humidity ?? 0;

  return (
    <>
      <div className="sensor-item">
        <div className="table-title">Температура</div>
        <div className={`table-val ${getValueColor(temperature)}`}>
          {loading ? (
            <Loader size="xs" />
          ) : hasWeatherData ? (
            `${temperature} °C`
          ) : (
            '0 °C'
          )}
        </div>
      </div>

      <div className="sensor-item">
        <div className="table-title">Давление</div>
        <div className={`table-val ${getValueColor(pressure)}`}>
          {loading ? (
            <Loader size="xs" />
          ) : hasWeatherData ? (
            `${pressure}`
          ) : (
            '0'
          )}
        </div>
      </div>

      <div className="sensor-item">
        <div className="table-title">Влажность</div>
        <div className={`table-val ${getValueColor(humidity)}`}>
          {loading ? (
            <Loader size="xs" />
          ) : hasWeatherData ? (
            `${humidity} %`
          ) : (
            '0 %'
          )}
        </div>
      </div>
    </>
  );
};

export default WeatherSensors;
